<template>
    <div class='add-to-home'>
        <br/>
        <div class="background">
            <img style="filter: brightness(45%);" :src="imageUrl" alt="">
        </div>
        <div class="install-app-container">
            <h3>Install Digital Business Card</h3>
            <div v-if="icon_Android">
                <div class="number">1.</div> Click the <img src="../assets/options_android.png" class="icon"/> icon above
            </div>
            <div v-if="icon_Iphone">
                <div class="number">1.</div> Click the <img src="../assets/options_iphone.jpg"  class="icon"/> icon below
            </div>
            <br/>
            <div  v-if="icon_Iphone || icon_Android">
                <div class="number">2.</div> Click "Add to Home Screen".        
            </div>
            <div v-if="!icon_Iphone && !icon_Android">
                <p>Sorry, this browser not supported. Please, copy the app url and open it into another browser (Chrome, Safari).</p>        
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { LoopingRhombusesSpinner  } from 'epic-spinners'
import { mapState } from 'vuex'

export default {
    name:"add-to-homescreen",
    components:{
        LoopingRhombusesSpinner 
    },
    computed: {
    ...mapState({
        imageUrl:state => state.common.homeImages[0].image,
        browser:state => state.standalone.browser,
     })
    },
    mounted:function(){
        this.icon_Android = false;
        this.icon_Iphone = false;
        var browser = this.showBrowser();
        if (browser == "Chrome" || browser == "SamsungBrowser") {
            this.icon_Android = true;
        }
        else if (browser == "Safari") {
            this.icon_Iphone = true;
        }
    },
    methods: {
        showBrowser()  {
            var ua = navigator.userAgent, tem,
                M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

            if(ua.indexOf("SamsungBrowser") != -1)
            {
                return "SamsungBrowser";
            }
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
            return M[0];
        },
        isChrome(){
                var isChromium = window.chrome;
                var winNav = window.navigator;
                var vendorName = winNav.vendor;
                var isOpera = winNav.userAgent.indexOf("OPR") > -1;
                var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
                var isIOSChrome = winNav.userAgent.match("CriOS");

            if(isIOSChrome){
                console.log('is Google Chrome on IOS');
                return false;
            } else if(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera == false && isIEedge == false) {
                console.log('is Google Chrome');
                return true;
            } else { 
                console.log('not Google Chrome');
                return false;
            }
        }
    },
    props: {
        title: { type: String, default: 'AddToHomescreen' },
        backLink: { type: Boolean, default: false },
        noRightMenu: { type: Boolean, default: false },
        showLogo: { type: Boolean, default: true }
    },
    data() {
        return{
            icon_Android:true,
            icon_Iphone:true,
            redirect: false,
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add-to-home{
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 100000;
    top: 0;
    background: #000;
}
.background{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}
.background>*{
    height: 100%;
    width: 100%;
    object-fit: cover;
}
h1,h2,h3,h4,h5,h6{
    text-align: center;
}
.install-app-container{
    background:#ffffff;
    margin-top:60%;
    margin-left:5px;
    margin-right:5px;
    padding:5px 10%;    
    padding-bottom: 25px;
}
.number
{
    display: inline-block;
    height: 30px;
    width:  25px;   
    text-align: center;   
    background: #144A8E;
    color: white;
    padding: 5px 8px;
}
.icon
{
    height: 25px;
    display: inline-block;
}
.loader{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background:  rgb(255, 255, 255);
    z-index: 9999999;
}
.none{
    display: none;
}
</style>



// WEBPACK FOOTER //
// add-to-homescreen.vue?3467f172